<coin-v2-card
  styleVariant="large"
  [class.has-file]="value">
  @if (!value) {
    <div class="select-file">
      <div class="text">
        <p>{{ 'gbr.file.info' | translate }}</p>
      </div>
      <coin-v2-button
        [type]="'primary'"
        [icon]="'add'"
        [iconPos]="'right'"
        [text]="'gbr.add' | translate"
        (click)="fileUpload.click()"></coin-v2-button>
      <input
        #fileUpload
        hidden
        type="file"
        (input)="handleFiles($event.target.files)" />
    </div>
  } @else {
    <div class="file-info">
      <div class="data-point">
        <p class="title">{{ 'gbr.file.filename' | translate }}</p>
        <p class="value">{{ value?.fileName }}</p>
      </div>
      <div class="data-point">
        <p class="title">{{ 'gbr.file.type' | translate }}</p>
        <p class="value">{{ getFileType(value) | uppercase }} {{ getFileSize(value) }}</p>
      </div>
      <div style="flex: 1"></div>
      <coin-icon-button
        type="secondary"
        icon="download"
        [disabled]="!value?.filePath"
        [matTooltip]="!value?.filePath ? ('gbr.file.can-not-download' | translate) : ''"
        (click)="download()"></coin-icon-button>
      @if (!disabled) {
        <coin-icon-button
          class="delete"
          type="primary"
          icon="delete"
          (click)="remove()"></coin-icon-button>
      }
    </div>
  }
</coin-v2-card>
